import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CookiesStorage } from './cookies-storage.service';
import { UserProfileService } from '../userProfile.service';
import { RolesEnum } from '../enums/role.enum';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(
    private _router: Router,
    private userProfileService: UserProfileService) {
  }

  canActivate(next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const token: string = CookiesStorage.getCookie('accessToken');
    const tokenExpiryDate: string = CookiesStorage.getCookie('tokenExpiryDate');

    // check if user authorized

    var profile = this.userProfileService.getProfile();
    var isAuthorized = true;

    if (!profile || profile === null || profile.isLoggedIn === false || this.userProfileService.isOnlyRoleExists(RolesEnum.Customer)) {
      // if dashboard
      if (next.routeConfig.path === "dashboard") {
        this._router.navigate(["/"]);
        return true;
      }
    }
    if (next.routeConfig.path === "") {
      if (profile && profile !== null && profile.isLoggedIn === true && !this.userProfileService.isOnlyRoleExists(RolesEnum.Customer)) {
        this._router.navigate(["/dashboard"]);
      } else {
        return true;
      }
    }
    if (this.userProfileService.isRoleExists(RolesEnum.SuperAdmin))
      isAuthorized = true;
    else
      isAuthorized = this.checkUserAuthorization(next.routeConfig.path)
    

const now = new Date();
const todayUtcDateOnly = new Date(
  now.getUTCFullYear(),
  now.getUTCMonth(),
  now.getUTCDate()
);


if (tokenExpiryDate) {
   console.log("tokenExpiryDate",tokenExpiryDate);
  
      const expiryMs = Number(tokenExpiryDate);
      const expiryDateUtc = new Date(expiryMs);

      // Create a DATE‑ONLY value in UTC
      const expiryUtcDateOnly = new Date(
        expiryDateUtc.getUTCFullYear(),
        expiryDateUtc.getUTCMonth(),
        expiryDateUtc.getUTCDate()
      );

      
     //console.log("expiryUtcDateOnly",expiryUtcDateOnly,"todayUtcDateOnly",todayUtcDateOnly);
     // console.log("token",token);
      
      if (expiryUtcDateOnly > todayUtcDateOnly) 
      {
        CookiesStorage.setCookie('accessToken', null);

        //console.log("Clear token- "," -token",token);
        this._router.navigate(['/account/login'], { queryParams: { redirectUrl: state.url } });
      }
}
    if (token && tokenExpiryDate && (+tokenExpiryDate > (new Date()).getTime()) && isAuthorized === true) {
      return true;
    }

    if (token && tokenExpiryDate && (+tokenExpiryDate > (new Date()).getTime()) && isAuthorized === false) {
      return false;
    }

    if (state.url && state.url !== null && state.url !== "")
      this._router.navigate(['/account/login'], { queryParams: { redirectUrl: state.url } });
    else
      this._router.navigate(['/account/login']);
    // you can save redirect url so after authing we can move them back to the page they requested
    return false;
  }       

  checkUserAuthorization(requestedPath: string) {

    switch (requestedPath) {
      case 'user/customer':
        return this.userProfileService.isRoleExists(RolesEnum.SuperAdmin) || this.userProfileService.isRoleExists(RolesEnum.Accountant)
        break;
      case 'user/employee':
      case 'configuration/setting':
        return this.userProfileService.isRoleExists(RolesEnum.SuperAdmin)
        break;
      case 'order/orders':
        return this.userProfileService.isRoleExists(RolesEnum.SuperAdmin) || this.userProfileService.isRoleExists(RolesEnum.Customer)
        break;
      case 'user/walkInCustomer':
        return this.userProfileService.isRoleExists(RolesEnum.SuperAdmin) || this.userProfileService.isRoleExists(RolesEnum.WalkInEmployee)
        break;
      case 'order/orderDetails/:orderId':
      case 'order/orderServiceDetails/:requestOrderDetailId':
      case 'order/ordersServices':
      case 'user/notifications':
        return this.userProfileService.isRoleExists(RolesEnum.SuperAdmin) || this.userProfileService.isRoleExists(RolesEnum.WalkInEmployee)
          || this.userProfileService.isRoleExists(RolesEnum.AuditEmployee) || this.userProfileService.isRoleExists(RolesEnum.AuditSupervisor)
          || this.userProfileService.isRoleExists(RolesEnum.Customer) || this.userProfileService.isRoleExists(RolesEnum.Employee)
          || this.userProfileService.isRoleExists(RolesEnum.Manager) || this.userProfileService.isRoleExists(RolesEnum.Supervisor)
          || this.userProfileService.isRoleExists(RolesEnum.Accountant) || this.userProfileService.isRoleExists(RolesEnum.Court)
        break;
      case 'dashboard':
        return this.userProfileService.isRoleExists(RolesEnum.SuperAdmin) || this.userProfileService.isRoleExists(RolesEnum.WalkInEmployee)
          || this.userProfileService.isRoleExists(RolesEnum.AuditEmployee) || this.userProfileService.isRoleExists(RolesEnum.AuditSupervisor)
          || this.userProfileService.isRoleExists(RolesEnum.Employee) || this.userProfileService.isRoleExists(RolesEnum.Court)
          || this.userProfileService.isRoleExists(RolesEnum.Manager) || this.userProfileService.isRoleExists(RolesEnum.Supervisor)
          || this.userProfileService.isRoleExists(RolesEnum.Accountant)
        break;
      case 'order/ordersServicesAssignment':
        return this.userProfileService.isRoleExists(RolesEnum.SuperAdmin) || this.userProfileService.isRoleExists(RolesEnum.Supervisor)
        break;
      case 'user/inquiryList':
        return this.userProfileService.isRoleExists(RolesEnum.SuperAdmin) || this.userProfileService.isRoleExists(RolesEnum.Inquiry)
        break;
    }
    return true;
  }
}
